import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { AuthService } from '@grainger/angular/services/auth.service';

@Component({
  selector: 'grainger-logout-button',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './logout-button.component.html',
  styleUrls: ['./logout-button.component.scss']
})
export class LogoutButtonComponent {
  @Input() path?: string | string[];
  @Output() clicked = new EventEmitter<void>();

  constructor(private auth: AuthService, private router: Router) {}

  onClick(): void {
    this.auth.logout();
    this.clicked.emit();

    const target = this.path ?? ['/auth', 'login'];
    this.router.navigate(Array.isArray(target) ? target : [target]);
  }
}
